import _ from "lodash";

import * as getConversations from '@/api/crm/messenger/getConversations';
import * as sendMessage from '@/api/crm/messenger/sendMessage.js';
import * as changeAssignee from '@/api/crm/messenger/changeAssignee.js';
import * as changeStatus from '@/api/crm/messenger/changeStatus.js';
import * as changeTopic from '@/api/crm/messenger/changeTopic.js';
import * as attachGuest from '@/api/crm/messenger/attachGuest.js';
import * as detachGuest from '@/api/crm/messenger/detachGuest.js';
import * as negotiatePubSub from '@/api/crm/messenger/negotiatePubSub.js';

import * as getPageVenueIdentities from '@/api/crm/messenger/getPageVenueIdentities.js';
import * as createPageVenueIdentity from '@/api/crm/messenger/createPageVenueIdentity.js';
import * as deletePageVenueIdentity from '@/api/crm/messenger/deletePageVenueIdentity.js';


export default {
  namespaced: true,
  state: {
    pubSubUrl: "",
    awaitingConfirmation: false,
    activeConversationId: "",
    conversations: [],
    pageVenueIdentities: [],
    latestMessageNum: 0,
  },
  mutations: {
    setActiveConversation(state, id) {
      state.activeConversationId = id;
    },
    gotPageVenueIdentities(state, payload) {
      state.pageVenueIdentities = payload;
    },
    gotConversations(state, payload) {
      state.conversations = payload;
    },
    addMessage(state, { convId, message }) {
      if (!state.conversations.some(e => e.id === convId)) return;
      state.conversations.find(e => e.id === convId).messages.push(message);
      if (!message.isSystemMessage) state.latestMessageNum++;
    },
    addConversation(state, newConversation) {
      state.conversations.push(newConversation);
      state.latestMessageNum++;
    },
    awaitingConfirmation(state, newState) {
      state.awaitingConfirmation = newState;
    },
    gotPubSubUrl(state, url) {
      state.pubSubUrl = url;
    },
    updateConversationProperty(state, { convId, property, value }) {
      state.conversations.find(e => e.id == convId)[property] = value;
      console.log("After change", state.conversations);
    },
  },
  actions: {
    async getAll({ commit, getters }, force = true) {
      if (!force && getters.conversations.length > 0) return;
      const result = await getConversations.get();
      console.log("Got all conversations", result);
      if (result) commit("gotConversations", result);
    },

    async sendMessage({ dispatch, commit }, dto) {
      commit("awaitingConfirmation", true)
      await sendMessage.post(dto);
    },

    async getPageVenueIdentities({ commit, getters }, force = true) {
      if (!force && getters.getPageVenueIdentities.length > 0) return;
      const result = await getPageVenueIdentities.get();
      if (result) commit("gotPageVenueIdentities", result);
    },

    async createPageVenueIdentity({ dispatch }, dto) {
      await createPageVenueIdentity.post(dto);
      await dispatch("getPageVenueIdentities")
    },

    async deletePageVenueIdentity({ dispatch }, id) {
      await deletePageVenueIdentity.del(id);
      await dispatch("getPageVenueIdentities")
    },

    async setStatus({ dispatch, commit }, dto) {
      await changeStatus.post(dto);
    },

    async setAssignee({ dispatch, commit }, dto) {
      await changeAssignee.post(dto);
    },

    async addTopic({ dispatch, commit }, dto) {
      await changeTopic.post({ ...dto, remove: false });
    },

    async removeTopic({ dispatch, commit }, dto) {
      await changeTopic.post({ ...dto, remove: true });
    },

    async attachGuest({ dispatch, commit }, dto) {
      await attachGuest.post(dto);
    },

    async detachGuest({ dispatch, commit }, dto) {
      await detachGuest.post(dto);
    },

    async negotiatePubSub({ commit }) {
      const result = await negotiatePubSub.get();
      commit("gotPubSubUrl", result)
    },

    handleSocketMessage({ commit }, dto) {
      console.log("Handling socket message", dto);
      switch (dto.pushType) {
        case "newMessage":
          commit("addMessage", { convId: dto.psid, message: dto.message });
          commit("awaitingConfirmation", false)
          break;
        case "newConversation":
          commit("addConversation", dto.conversation);
          break;
        case "changeAssignee":
          commit("updateConversationProperty", { convId: dto.psid, property: "assignee", value: dto.message });
          commit("addMessage", { convId: dto.psid, message: dto.systemMessage });
          break;
        case "changeStatus":
          commit("updateConversationProperty", { convId: dto.psid, property: "status", value: dto.message });
          commit("updateConversationProperty", { convId: dto.psid, property: "isOpen", value: dto.message == "OPEN" });
          commit("addMessage", { convId: dto.psid, message: dto.systemMessage });
          break;
        case "changeTopics":
          commit("updateConversationProperty", { convId: dto.psid, property: "topics", value: dto.message });
          break;
        case "changeGuest":
          commit("updateConversationProperty", { convId: dto.psid, property: "guestId", value: dto.message });
          commit("addMessage", { convId: dto.psid, message: dto.systemMessage });
          break;
      }
    }

  },
  getters: {
    conversation: state => (id) => state.conversations.find(e => e.id === id),
    conversationLastMessage: (state, getters) => (id) => [...getters.conversation(id).messages.filter(e => !e.isSystemMessage)].pop(),
    conversationIsOpen: (state, getters) => (id) => getters.conversation(id).isOpen,

    conversations: state => state.conversations,

    activeConversation: state => state.conversations.find(e => e.id === state.activeConversationId),
    activeConversationId: state => state.activeConversationId,

    awaitingConfirmation: state => state.awaitingConfirmation,

    pubSubUrl: state => state.pubSubUrl,
    pageVenueIdentities: state => state.pageVenueIdentities,

    latestMessageNum: state => state.latestMessageNum,
  }
};
